(ns dre.modals.app-settings.views
  (:require
   ["antd" :refer [Spin]]
   [dre.app.events :as app-events]
   [dre.components.collapse :refer [collapse]]
   [dre.components.dropdown :refer [dropdown dropdown-list]]
   [dre.components.icon :refer [fa-icon]]
   [dre.components.inputs :refer [checkbox]]
   [dre.components.form :refer [form form-item]]
   [dre.components.icons-iconoir :refer [icoinor-icon]]
   [dre.i18n.views :refer [tr]]
   [dre.modals.app-settings.events :as events]
   [dre.modals.modal-window :refer [modal-window]]
   [dre.utils.bem :as bem]
   [re-frame.core :as rf]
   [reagent.core :as r]))

(def frequency-options
  ["daily" "weekly" "biweekly" "monthly"])

(def recent-options
  ["5" "all"])

(defn settings-content
  []
  (let [data @(rf/subscribe [::events/state])
        loading? (= :loading (:state data))
        settings (get-in data [:settings :signals])
        set-existing-signals? (:set-existing-signals? data)
        email? (get-in settings [:email?])
        articles (get-in settings [:email :articles])
        freq (get-in settings [:email :frequency])
        notify-when-zero? (get-in settings [:email :notify-when-zero?])
        changed? (get-in settings [:email :changed?])]
    (if loading?
      [:div
       {:style {:justify-content "center" :display "flex" :width "100%"}}
       [:> Spin]]
      [:<>
       [form
        {}
        [:<> [form-item
              {}
              [checkbox
               {:checked email?
                :on-change #(rf/dispatch [::events/update-data [:settings :signals :email?] (not email?)])}
               [tr "Email notification"]]]
         (when email?
           [:<>
            [form-item
             {:label [tr "Frequency"]}
             [dropdown
              {:alignment :left
               :anchor
               [:button
                {:class (bem/bm :button [:light :small])}
                freq
                [icoinor-icon :nav-arrow-down]]
               :content
               [dropdown-list
                (for [v frequency-options]
                  ^{:key v}
                  [:a
                   {:on-click #(rf/dispatch [::events/update-data [:settings :signals :email :frequency] v])}
                   v])]}]]
            [form-item
             {:label [tr "Most recent articles"]}
             [dropdown
              {:alignment :left
               :anchor
               [:button
                {:class (bem/bm :button [:light :small])}
                articles
                [icoinor-icon :nav-arrow-down]]
               :content
               [dropdown-list
                (for [v recent-options]
                  ^{:key v}
                  [:a
                   {:on-click #(rf/dispatch [::events/update-data [:settings :signals :email :articles] v])}
                   v])]}]]
            [form-item
             {}
             [checkbox
              {:checked changed?
               :on-change #(rf/dispatch [::events/update-data [:settings :signals :email :changed?] (not changed?)])}
              [tr "Include changed articles"]]]
            [form-item
             {}
             [checkbox
              {:checked notify-when-zero?
               :on-change #(rf/dispatch [::events/update-data [:settings :signals :email :notify-when-zero?] (not notify-when-zero?)])}
              [tr "Receive update for saved search when no new items"]]]])
         [form-item
          {}
          [checkbox
           {:checked set-existing-signals?
            :on-change #(rf/dispatch [::events/update-data [:set-existing-signals?] (not set-existing-signals?)])}
           [:span
            {:style {:display "flex"}}
            [:span
             {:style {:width "20px"}}
             [fa-icon :warning]]
            [tr "Overwrite all my existing saved searches with these settings"]]]]]]])))

(defn user-content 
  []
  (let [user @(rf/subscribe [::app-events/user])]
    [:<> 
     [form 
      {}
      [:<>
       [form-item
        {:label [tr "Name"]}
        (:name user)]
       [form-item
        {:label [tr "Email"]}
        (:email user)]]]]))

(defn content
  []
  [:div 
   {:style {:width "100%"}}
   [collapse 
    [{:label (r/as-element [:b [tr "User information"]])
      :children (r/as-element [user-content])}
     {:label (r/as-element [:b [tr "Default saved search settings"]])
      :children (r/as-element [settings-content])}]
    :all]])

(defn view
  []
  (let []
    [modal-window
     {:title "App Settings"
      :content content
      :submit? true
      :submit-text [tr "Save"]
      :submit-disabled? false
      :on-submit #(rf/dispatch [::events/save])}]))